module.exports = __webpack_public_path__ + "static/media/Wiggins_Tigers_Logo.5ee2b2a9.png";